<div class="page-container" animate.enter="route-slide-in-right" animate.leave="route-slide-out-right">
  <div class="page-title-row flex flex-align-center gap-sm mb-md">
    <app-back-button [ariaLabel]="'settings.back' | translate" />
    <h2>{{ 'settings.billing.title' | translate }}</h2>
  </div>

  <app-card-content>
    @if (state() === 'loading') {
      <div class="loading-container flex flex-column flex-align-center p-lg">
        <app-spinner />
      </div>
    }

    @if (state() === 'error') {
      <div class="error-container p-lg" data-testid="billing-settings-error">
        <p>{{ 'billingSettings.loadError' | translate }}</p>
      </div>
    }

    @if (state() === 'loaded' && subscription(); as sub) {
      <div class="billing-content flex flex-column gap-lg">
        <app-card>
          <div class="p-lg flex flex-column gap-md">
            <div class="plan-header flex flex-justify-space-between flex-align-center">
              <div>
                <h2>{{ sub.plan.name }}</h2>
                <span class="plan-price">{{ formatPrice(sub.plan.priceMonthlyCents) }}</span>
              </div>
              <app-chip [color]="sub.status === 'active' ? 'success' : 'warning'" data-testid="billing-status-chip">
                {{ sub.status }}
              </app-chip>
            </div>

            <div class="usage-row">
              <div class="usage-label">
                <span>{{ 'billingSettings.recordUsage' | translate }}</span>
                <span>{{ sub.recordUsage.used }} / {{ sub.recordUsage.limit === -1 ? ('pricing.unlimitedRecords' | translate) : sub.recordUsage.limit }}</span>
              </div>
              <div class="usage-bar">
                <div class="usage-bar-fill" [style.width.%]="usagePercent(sub.recordUsage.used, sub.recordUsage.limit)"></div>
              </div>
            </div>

            <div class="usage-row">
              <div class="usage-label">
                <span>{{ 'billingSettings.seatUsage' | translate }}</span>
                <span>{{ sub.seatUsage.used }} / {{ sub.seatUsage.limit === -1 ? ('pricing.unlimitedSeats' | translate) : sub.seatUsage.limit }}</span>
              </div>
              <div class="usage-bar">
                <div class="usage-bar-fill" [style.width.%]="usagePercent(sub.seatUsage.used, sub.seatUsage.limit)"></div>
              </div>
            </div>

            <app-button variant="outlined" [disabled]="actionInFlight()" (click)="manageBilling()" data-testid="manage-billing-button">
              {{ 'billingSettings.manageBilling' | translate }}
            </app-button>
          </div>
        </app-card>

        @if (otherPlans().length > 0) {
          <app-card>
            <div class="p-lg flex flex-column gap-md">
              <h3>{{ 'billingSettings.upgradeTitle' | translate }}</h3>
              <div class="plan-options">
                @for (plan of otherPlans(); track plan.id) {
                  <div class="plan-option flex flex-justify-space-between flex-align-center">
                    <div>
                      <strong>{{ plan.name }}</strong>
                      <span class="plan-price">{{ formatPrice(plan.priceMonthlyCents) }}</span>
                    </div>
                    <app-button variant="filled" [disabled]="actionInFlight()" (click)="upgradeToPlan(plan)"
                      [attr.data-testid]="'upgrade-to-' + plan.id">
                      {{ 'billingSettings.switchPlan' | translate }}
                    </app-button>
                  </div>
                }
              </div>
            </div>
          </app-card>
        }
      </div>
    }
  </app-card-content>
</div>
